/**
 * Project : workspace
 * File    : AuthNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.graph.auth

import androidx.navigation.NavGraph
import androidx.navigation.NavHostController
import androidx.navigation.compose.composable
import androidx.navigation.createGraph
import navigation.route.auth.AuthNavRoute
import presentation.screens.common.auth.LoginScreen
import presentation.screens.common.auth.OTPScreen
import presentation.screens.common.auth.SetMPinScreen
import presentation.screens.common.auth.SignUpScreen
import presentation.screens.common.auth.VerifyMPinScreen

/**
 * Represents the auth nav graph class.
 */

class AuthNavGraph {
    fun navGraph(controller: NavHostController): NavGraph {
        val graph =
            controller.createGraph(startDestination = AuthNavRoute.LOGIN) {
                composable(route = AuthNavRoute.LOGIN) {
                    LoginScreen().Content()
                }
                composable(route = AuthNavRoute.SEND_OTP) {
                    OTPScreen().Content()
                }
                composable(route = AuthNavRoute.VERIFY_OTP) {
                    OTPScreen().Content()
                }
                composable(route = AuthNavRoute.REGISTER) {
                    SignUpScreen().Content()
                }
                composable(route = AuthNavRoute.SET_MPIN) {
                    SetMPinScreen().Content()
                }
                composable(route = AuthNavRoute.VERIFY_MPIN) {
                    VerifyMPinScreen().Content()
                }
            }
        return graph
    }
}